import { PharmacistInterface, User } from "@/vuex/auth/types";
import { UserState } from "@/vuex/modules/user/user.types";
import { RootState } from "@/vuex/types";
import { TablePagination } from "helix-vue-components";
import { GetterTree } from "vuex";

type UserGetter = GetterTree<UserState, RootState>;

export const getters: UserGetter = {
  users(state: UserState): User[] {
    return state.users;
  },
  pagination(state: UserState): TablePagination | null {
    return state.pagination;
  },
  loading(state: UserState): boolean {
    return state.loading;
  },
  currentUser(state: UserState): User | null {
    return state.currentUser;
  },
  pharmacistInfo(state: UserState): PharmacistInterface | null {
    return state.pharmacistInfo;
  },
  pharmacistInfoFetched(state: UserState): boolean {
    return state.pharmacistInfoFetched;
  },
  disabledMode(state: UserState): boolean {
    return state.disabledMode;
  }
};
